<template>
    <div :class="containerClass">
        <b-form-input
            v-if="showMinInput"
            :class="`input ${inputsClasses.minInput}`"
            no-wheel
            size="sm"
            type="number"
            :value="minValue"
            :state="minValueState"
            @input="onInputValue('minValue', $event)"
        />
        <b-form-input
            :class="`input ${inputsClasses.maxInput}`"
            no-wheel
            size="sm"
            type="number"
            :value="maxValue"
            :state="maxValueState"
            @input="onInputValue('maxValue', $event)"
        />
    </div>
</template>
<script>
export default {
    props: {
        type: {
            type: String,
            default: null,
        },
        showMinInput: {
            type: Boolean,
            default: false,
        },
        minValue: {
            type: Number,
            default: null,
        },
        maxValue: {
            type: Number,
            default: null,
        },
        minValueState: {
            type: Boolean,
            default: null,
        },
        maxValueState: {
            type: Boolean,
            default: null,
        },
    },
    computed: {
        containerClass() {
            const baseClass = 'd-flex '

            if (this.type == 'column') {
                const flexDirection = this.showMinInput
                    ? 'flex-column-reverse'
                    : 'flex-column'

                return baseClass + flexDirection
            }

            return this.showMinInput
                ? baseClass + 'justify-content-between'
                : ''
        },
        inputsClasses() {
            if (this.type == 'column') {
                return {
                    minInput: this.showMinInput ? 'mt-auto mb-4' : '',
                    maxInput: this.showMinInput ? '' : 'mb-auto',
                }
            }

            return {
                minInput: this.showMinInput ? 'mt-auto' : '',
                maxInput: this.showMinInput ? '' : 'float-right',
            }
        },
    },
    methods: {
        onInputValue(prop, value) {
            const parsedValue = parseFloat(value)
            this.$emit(`update:${prop}`, parsedValue)
            this.$emit('update', prop, parsedValue)
        },
    },
}
</script>
<style lang="sass" scoped>
.input
    width: 75px
    background-color: #EBF9FF
</style>
